import { TextTestID } from "@/constants/TestID";
import { FAIconName, Icon, Text } from "@/ui/core";
import { BaseCard, Box, HStack, VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface BookingOptionCardProps {
  id: string;
  infoLabel?: string;
  isSelected?: boolean;
  onSelect?: (id: string) => void;
  title: string;
}

const BookingOptionCard = ({
  id,
  infoLabel,
  isSelected,
  onSelect,
  title,
}: BookingOptionCardProps) => {
  const baseTestID = joinTestIDs(id, "booking-option");

  const infoLabelColor = isSelected
    ? ColorToken.Primary100
    : ColorToken.NeutralSecondary;

  const handlePress = () => {
    onSelect?.(id);
  };

  return (
    <BaseCard
      isSelected={isSelected}
      onPress={handlePress}
      testID={baseTestID}
      variant="secondary"
    >
      <VStack gap={10}>
        <HStack justifyContent="space-between">
          <Text
            testID={joinTestIDs(baseTestID, TextTestID.Title)}
            variant="bodyMedium"
          >
            {title}
          </Text>

          {isSelected && (
            <Icon
              accessibilityLabel={`${title} selected`}
              color={ColorToken.Primary100}
              name={FAIconName.Check}
              size="sm"
              testID={joinTestIDs(baseTestID, "selected")}
            />
          )}
        </HStack>
        {infoLabel && (
          <HStack gap={4}>
            <Icon
              color={infoLabelColor}
              name={FAIconName.InfoCircle}
              size="sm"
              testID={joinTestIDs(baseTestID, "info")}
            />
            <Box flex={1}>
              <Text
                color={infoLabelColor}
                testID={joinTestIDs(baseTestID, "info-label")}
                variant="caption"
              >
                {infoLabel}
              </Text>
            </Box>
          </HStack>
        )}
      </VStack>
    </BaseCard>
  );
};

export type { BookingOptionCardProps };
export default BookingOptionCard;
